import useNetwork from './network';
import { IRegulationModel } from './models/regulationModel';

const getRegulations = async (lng: string, provinceId: number) => {
    const { fetchRegulations } = useNetwork();
    const result = await fetchRegulations(lng, provinceId);

    if (result.status === 200) {
        return (await result.json()) as IRegulationModel[];
    }
};

export default getRegulations;
